
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobangloretaxi() {



  const cardData =
  {
    keyword: 'Pune to Bangalore Taxi Service',
    heading: 'AB Ghule Cabs: Pune to Bangalore Taxi Service',
    headingDescription: 'Looking to travel from Pune to Bangalore? AB Ghule Cabs offers reliable, comfortable, and affordable taxi services to make your journey from Pune to Bangalore hassle-free. Whether you are heading to Bangalore for business, sightseeing, or visiting family, our well-maintained fleet and experienced drivers ensure you enjoy a smooth and pleasant ride. The approximate distance from Pune to Bangalore is around 840 km.',

    top: 'Top Places to Visit in Bangalore with AB Ghule Cabs',

    "topPlaces": [
  {
    title: "Bangalore Palace",
    description: "A majestic palace showcasing Tudor-style architecture, Bangalore Palace is a must-visit. It reflects the royal heritage of the city, with grand interiors and expansive grounds."
  },
  {
    title: "Lalbagh Botanical Garden",
    description: "One of the oldest and most well-maintained gardens in India, Lalbagh is home to thousands of plant species and features a glass house inspired by London’s Crystal Palace."
  },
  {
    title: "Cubbon Park",
    description: "A lush green oasis in the city, Cubbon Park is perfect for a leisurely walk or a picnic. It’s a serene spot to escape the hustle and bustle of urban life."
  },
  {
    title: "Vidhana Soudha",
    description: "This imposing building is the seat of the Karnataka state legislature and is a prime example of neo-Dravidian architecture. It’s a must-visit for history and architecture enthusiasts."
  },
  {
    title: "Bangalore Fort",
    description: "A historical fort that dates back to the 16th century, Bangalore Fort is a significant landmark, showcasing the city’s colonial past and military history."
  },
  {
    title: "Bannerghatta National Park",
    description: "Located just outside Bangalore, Bannerghatta National Park offers an exciting opportunity to experience wildlife. It includes a zoo, butterfly park, and a safari for animal enthusiasts."
  },
  {
    title: "ISKCON Temple",
    description: "One of the largest ISKCON temples in India, this beautiful temple offers a peaceful environment for worship and spiritual learning, with a great view of the city."
  },
  {
    title: "Ulsoor Lake",
    description: "This scenic lake is perfect for a boat ride and offers a peaceful retreat from the city’s noise. It’s one of Bangalore’s most picturesque spots."
  },
  {
    title: "Nandi Hills",
    description: "A short drive from Bangalore, Nandi Hills offers stunning views and a cool breeze. It’s ideal for a quick getaway and perfect for photography or a peaceful retreat."
  },
  {
    title: "Commercial Street",
    description: "For shopping enthusiasts, Commercial Street is a bustling market offering a variety of clothes, accessories, and local handicrafts at affordable prices."
  }
],


services: [
    {
      "name": "Pune to Bangalore Taxi Service",
      description: "Travel comfortably and conveniently from Pune to Bangalore with AB Ghule Cabs. Whether you're traveling for business, leisure, or a family getaway, we offer a range of services to suit your needs. Our fleet of vehicles includes everything from economy cars to luxury options, ensuring a comfortable journey for all. With professional drivers, modern amenities, and excellent customer service, your trip will be smooth and hassle-free."
    },
    {
      "name": "Pune to Bangalore Taxi Booking",
      description: "Booking a taxi from Pune to Bangalore with AB Ghule Cabs is easy and hassle-free. You can make your booking online or by contacting our friendly customer support team. Whether you're planning a one-way ride or a round trip, we offer flexible booking options to fit your schedule. Our easy-to-use platform ensures you can book your ride in just a few minutes, with reliable service guaranteed."
    },
    {
      "name": "Pune to Bangalore Car Rental",
      description: "AB Ghule Cabs offers Pune to Bangalore car rental services at competitive rates. Whether you need a compact sedan, a luxury SUV, or a larger vehicle for a group, our fleet caters to all preferences and budgets. All our rental vehicles are well-maintained and come with professional drivers who are experienced and knowledgeable about the best routes for a seamless journey."
    },
    {
      "name": "Pune to Bangalore Taxi Rates",
      description: "Our Pune to Bangalore taxi rates are affordable and transparent, with no hidden fees. We offer competitive pricing for all types of vehicles, ensuring you get the best value for your journey. Whether you're looking for an economy car or a luxury vehicle, our rates are designed to fit various budgets while maintaining the highest standards of service."
    },
    {
      "name": "Pune to Bangalore Cab Charges",
      description: "The Pune to Bangalore cab charges vary depending on the vehicle type and service you choose. At AB Ghule Cabs, we provide clear and upfront pricing with no hidden charges, ensuring complete transparency. From fuel to driver fees and toll charges, all expenses are included in the quoted price, so you can relax knowing there will be no surprises along the way."
    },
    {
      "name": "Pune to Bangalore Cab Pricing",
      description: "We offer flexible and transparent Pune to Bangalore cab pricing based on the type of vehicle and distance of travel. Whether you're opting for a one-way journey or a round-trip, our customized options ensure that your travel needs are met at competitive rates. Choose from a variety of vehicles, and let us handle the details to ensure a comfortable and cost-effective ride."
    },
    {
      "name": "Pune to Bangalore Private Car Hire",
      description: "For a more exclusive and private experience, choose AB Ghule Cabs for your Pune to Bangalore private car hire. Our well-maintained vehicles are equipped with modern amenities to ensure your journey is both comfortable and relaxing. Whether for business or leisure, our private car hire service allows you to travel in style and privacy, with flexible scheduling and routes to suit your needs."
    },
    {
      "name": "Pune to Bangalore Cab Cost",
      description: "The cost of your Pune to Bangalore cab ride is based on factors such as distance, vehicle type, and additional services. AB Ghule Cabs offers transparent pricing with no hidden fees, so you can rest assured that you’ll get the best value for your money. Whether you need a luxury ride or a budget-friendly option, our pricing ensures you receive excellent service without any surprises."
    },
    {
      "name": "Pune to Bangalore Taxi Service Charges",
      description: "Our Pune to Bangalore taxi service charges are competitive and designed to fit your travel budget. We ensure that you get value for money without compromising on comfort or convenience. Whether you're traveling for business or leisure, we offer a variety of vehicles to suit your needs, each with a professional driver to make your journey as smooth and comfortable as possible."
    },
    {
      "name": "Pune to Bangalore Travel Cabs",
      description: "For a smooth and comfortable ride, choose AB Ghule Cabs for your Pune to Bangalore travel. We offer a variety of vehicles, from economy sedans to spacious SUVs and luxury cars, to ensure your journey is comfortable and enjoyable. Whether you're traveling alone or with family, we have the perfect vehicle to meet your travel needs."
    },
    {
      "name": "Pune to Bangalore Taxi",
      description: "AB Ghule Cabs provides reliable and comfortable taxi services from Pune to Bangalore. Whether you’re traveling for business or a vacation, we have a wide range of vehicles to choose from. Our experienced drivers ensure timely arrivals and smooth journeys, so you can enjoy a stress-free ride to your destination."
    },
    {
      "name": "Pune to Bangalore Cab Booking",
      description: "Booking your Pune to Bangalore cab with AB Ghule Cabs is quick and easy. Simply select your preferred vehicle and pickup time, and you’re all set for your journey. We offer a hassle-free booking process, with multiple payment options and reliable service to ensure your travel experience is as smooth as possible."
    },
    {
      "name": "Pune to Bangalore Cab Service",
      description: "AB Ghule Cabs offers dependable and punctual Pune to Bangalore cab services, ensuring you travel in comfort and on time. Our fleet includes a range of vehicles to suit your travel needs, and all of our cars are well-maintained for a smooth ride. Whether you need a one-way trip or a round trip, our cab service is designed to meet all your needs."
    },
    {
      "name": "Pune to Bangalore Taxi Fare",
      description: "Our Pune to Bangalore taxi fare is designed to be both affordable and transparent. We provide a detailed breakdown of costs, including tolls, fuel, and driver charges, so you know exactly what to expect. Enjoy a comfortable and stress-free ride at competitive rates with AB Ghule Cabs."
    },
    {
      "name": "Taxi from Pune to Bangalore",
      description: "Looking for a taxi from Pune to Bangalore? AB Ghule Cabs offers a range of vehicles, from sedans to SUVs, to suit your travel needs and group size. We guarantee a timely, comfortable, and reliable ride, with experienced drivers familiar with the best routes for a smooth journey."
    },
    {
      "name": "Pune to Bangalore Innova Cab",
      description: "Travel in comfort and style with our Innova cabs from Pune to Bangalore. Perfect for families or groups, our Innova vehicles offer ample space, modern amenities, and a smooth ride. With AB Ghule Cabs, you can enjoy a comfortable and luxurious journey, with a professional driver ensuring your safety and convenience."
    },
    {
      "name": "Pune to Bangalore Tempo Traveller on Rent",
      description: "For larger groups traveling from Pune to Bangalore, our Tempo Traveller on rent is the ideal choice. Spacious, comfortable, and well-equipped, it’s perfect for family trips, corporate outings, or group tours. Enjoy a relaxed journey with plenty of space for everyone, while our professional driver takes care of the road."
    },
    {
      "name": "Pune to Bangalore Sedan Car on Rent",
      description: "If you're traveling solo or with a small group, our Pune to Bangalore sedan car rental service is the perfect choice. With vehicles like the Swift Dzire or Toyota Etios, you’ll enjoy a comfortable and economical journey. These vehicles are ideal for short trips and offer excellent fuel efficiency without compromising on comfort."
    },
    {
      "name": "Pune to Bangalore Ertiga Car on Rent",
      description: "For small families or groups, the Ertiga car rental is a great option. Spacious, fuel-efficient, and comfortable, our Pune to Bangalore Ertiga car offers the perfect balance of space and practicality. It’s an ideal choice for medium-sized groups or families looking for a comfortable ride at an affordable rate."
    },
    {
      "name": "Pune to Bangalore Swift Car on Rent",
      description: "Looking for a compact, affordable ride for your journey from Pune to Bangalore? Our Swift car on rent offers the perfect solution. Comfortable and fuel-efficient, it’s ideal for solo travelers or couples. Book a Swift car for a cost-effective, smooth, and enjoyable journey."
    },
    {
      "name": "Pune to Bangalore Mini Bus on Rent",
      description: "For larger groups traveling to Bangalore, our Pune to Bangalore mini bus on rent is the perfect choice. Spacious and comfortable, our mini buses can accommodate more passengers and are perfect for family gatherings, corporate events, or group tours. With ample seating and modern amenities, the mini bus ensures a smooth and comfortable journey for everyone."
    },
    {
      "name": "Pune to Bangalore Tempo Traveller on Rent",
      description: "Choose our Pune to Bangalore Tempo Traveller for larger groups or corporate outings. It offers ample space, modern facilities, and a comfortable travel experience. Whether for a long-distance journey or a group outing, the Tempo Traveller ensures that everyone travels in comfort, with plenty of space for luggage and a professional driver to make the trip hassle-free."
    },
    {
      "name": "Pune to Bangalore Taxi Service Contact Number",
      description: "For bookings or inquiries, contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Bangalore taxi services. Our friendly team is available to assist you and ensure a smooth and enjoyable ride to your destination."
    }
  ],

  tableData: [
    ["Pune to Bangalore Taxi Service", "-Pune to Bangalore Taxi Booking"],
    ["Pune to Bangalore Car Rental", "-Pune to Bangalore Taxi Rates"],
    ["Pune to Bangalore Cab Charges", "-Pune to Bangalore Cab Pricing"],
    ["Pune to Bangalore Private Car Hire", "-Pune to Bangalore Cab Cost"],
    ["Pune to Bangalore Taxi Service Charges", "-Pune to Bangalore Travel Cabs"],
    ["Pune to Bangalore Taxi", "-Pune to Bangalore Cab"],
    ["Pune to bangalore cab booking", "-Pune to bangalore cab service"],
    ["Pune to bangalore taxi fare", "-Taxi from pune to bangalore"],
    ["Pune to Bangalore Innova Cab", "-Pune to bangalore tempo traveller on rent"],
    ["Pune to bangalore sedan car on rent", "-Pune to bangalore ertiga car on rent"],
    ["Pune to bangalore swift car on rent", "-Pune to bangalore mini bus on rent"],
    ["Pune to bangalore tempo traveller on rent", ""]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Professional Service",
      WhyChoosedescription: "AB Ghule Cabs offers a reliable and professional taxi service for your journey from Pune to Bangalore. Our fleet of well-maintained vehicles and experienced drivers ensure a smooth and enjoyable trip, with the focus on your comfort and safety."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer competitive and transparent pricing for all our Pune to Bangalore trips. Our fares are clear with no hidden charges, ensuring that you get the best value for your money. Whether you're traveling for business or leisure, we have pricing options to suit your budget."
    },
    {
      WhyChooseheading: "Wide Range of Vehicles",
      WhyChoosedescription: "Whether you prefer a sedan for a solo trip, an SUV for a group journey, or a luxury vehicle for a comfortable ride, we have a variety of cars to suit your needs. All vehicles are regularly cleaned and well-maintained for your comfort."
    },
    {
      WhyChooseheading: "Experienced and Courteous Drivers",
      WhyChoosedescription: "Our drivers are professional, experienced, and well-versed in the best routes from Pune to Bangalore. They ensure a safe and timely journey, while also offering excellent customer service throughout the ride."
    },
    {
      WhyChooseheading: "On-Time Pick-Up and Drop-Off",
      WhyChoosedescription: "We value your time, and our drivers ensure timely pick-up from your location in Pune and prompt drop-off at your destination in Bangalore. With AB Ghule Cabs, you can count on punctuality."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether it's an early morning or late-night journey, AB Ghule Cabs is available 24/7 for your convenience. Our customer service is always ready to assist you with bookings, cancellations, or modifications."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking your Pune to Bangalore taxi is easy and hassle-free. You can book through our website, mobile app, or by contacting our customer service team. We offer quick and convenient booking options to meet your travel needs."
    }
  ]
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi from Pune to Bangalore?',
      answer: 'You can book a taxi through our website, mobile app, or by calling our customer service team for assistance.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a one-way trip from Pune to Bangalore?',
      answer: 'The one-way fare for a sedan typically ranges from ₹9,000 to ₹10,500, depending on the vehicle type.',
    },
    {
      id: 'FAQ3',
      question: 'Is the fare inclusive of taxes and tolls?',
      answer: 'Yes, the fare is inclusive of taxes, tolls, and other additional charges.',
    },
    {
      id: 'FAQ4',
      question: 'How long will the journey from Pune to Bangalore take?',
      answer: 'The journey usually takes about 12 to 14 hours, depending on traffic conditions and the chosen route.',
    },
    {
      id: 'FAQ5',
      question: 'Can I book a round-trip for Pune to Bangalore?',
      answer: 'Yes, we offer round-trip bookings, and we can provide a customized fare based on your travel needs.',
    },
    {
      id: 'FAQ6',
      question: 'Can I choose my pick-up location in Pune?',
      answer: 'Yes, we offer pick-up from any location in Pune, whether it\'s your residence, hotel, or office.',
    },
    {
      id: 'FAQ7',
      question: 'Are the vehicles air-conditioned?',
      answer: 'Yes, all our vehicles are air-conditioned for your comfort throughout the journey.',
    },
    {
      id: 'FAQ8',
      question: 'How do I pay for the ride?',
      answer: 'You can make the payment via cash, credit/debit card, or through our mobile app.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'Any additional charges for waiting or detours will be communicated to you in advance. We ensure transparency in pricing.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Nikhil Rao',
      feedback: 'I had an amazing experience traveling from Pune to Bangalore with AB Ghule Cabs. The driver was very professional, and the ride was comfortable. I would definitely choose them for my future trips.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Anjali Mehta',
      feedback: 'AB Ghule Cabs made my long journey from Pune to Bangalore seamless. The vehicle was well-maintained, and the driver was courteous. I arrived on time and felt very comfortable throughout the trip.',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Bangalore Taxi Service | Affordable Taxi & Car Rental</title>
  <meta name="description" content="Book a taxi from Pune to Bangalore with AB Ghule Cabs. Get the best fares for one-way and round-trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Bangalore Taxi Service, Pune to Bangalore Taxi Booking, Pune to Bangalore Car Rental, Pune to Bangalore Taxi Rates, Pune to Bangalore Cab Charges, Pune to Bangalore Cab Pricing, Pune to Bangalore Private Car Hire, Pune to Bangalore Cab Cost, Pune to Bangalore Taxi Service Charges, Pune to Bangalore Travel Cabs, Pune to Bangalore Taxi, Pune to Bangalore Cab, Pune to Bangalore Cab Booking, Pune to Bangalore Cab Service, Pune to Bangalore Taxi Fare, Taxi from Pune to Bangalore, Pune to Bangalore Innova Cab, Pune to Bangalore Tempo Traveller on Rent, Pune to Bangalore Sedan Car on Rent, Pune to Bangalore Ertiga Car on Rent, Pune to Bangalore Swift Car on Rent, Pune to Bangalore Mini Bus on Rent" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Bangalore Taxi Service | Affordable Taxi & Car Rental" />
  <meta property="og:description" content="Book a taxi from Pune to Bangalore with AB Ghule Cabs. Get the best fares for one-way and round-trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-bangalore-taxi.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-bangalore-taxi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Bangalore Taxi Service",
        description: "Book a taxi from Pune to Bangalore with AB Ghule Cabs. Get the best fares for one-way and round-trip cabs. Affordable car rental services available. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-bangalore-taxi",
        "logo": "https://abghulecabs.com/images/pune-to-bangalore-taxi.jpg",
        "image": "https://abghulecabs.com/images/pune-to-bangalore-taxi.jpg",
        "priceRange": "₹6000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-bangalore-taxi",
          "priceCurrency": "INR",
          "price": "6000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rohit P"
            },
            "datePublished": "2024-10-05",
            "reviewBody": "Smooth and comfortable ride from Pune to Bangalore. The driver was very courteous and the car was well-maintained. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sanya T"
            },
            "datePublished": "2024-08-15",
            "reviewBody": "Excellent service for our Pune to Bangalore trip. The cab was clean and the driver professional. Great experience overall!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Bangalore Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-bangalore-taxi"
        },
        "keywords": "Pune to Bangalore Taxi Service, Pune to Bangalore Taxi Booking, Pune to Bangalore Car Rental, Pune to Bangalore Taxi Rates, Pune to Bangalore Cab Charges, Pune to Bangalore Cab Pricing, Pune to Bangalore Private Car Hire, Pune to Bangalore Cab Cost, Pune to Bangalore Taxi Service Charges, Pune to Bangalore Travel Cabs, Pune to Bangalore Taxi, Pune to Bangalore Cab, Pune to Bangalore Cab Booking, Pune to Bangalore Cab Service, Pune to Bangalore Taxi Fare, Taxi from Pune to Bangalore, Pune to Bangalore Innova Cab, Pune to Bangalore Tempo Traveller on Rent, Pune to Bangalore Sedan Car on Rent, Pune to Bangalore Ertiga Car on Rent, Pune to Bangalore Swift Car on Rent, Pune to Bangalore Mini Bus on Rent"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/55.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetobangloretaxi;